import type { ReactNode } from 'react';
import React, { ComponentPropsWithRef, FC, forwardRef, PropsWithChildren } from 'react';
import { Text } from '@components/Text/Text.component';
import { TextProps } from '@components/Text/Text.types';

export type LabelProps = {
  label?: ReactNode | string;
  labelI18n?: string;
  labelFlavour?: TextProps['flavour'];
  labelVariant?: TextProps['variant'];
  required?: boolean;
  labelTag?: TextProps['tag'];
  className?: string;
};

export const Label: FC<PropsWithChildren<LabelProps & ComponentPropsWithRef<'h1'>>> = forwardRef(
  (
    { label, labelI18n, labelFlavour, labelVariant = 'h6', required, children, labelTag = 'span', ...rest },
    labelRef
  ) => {
    return label || labelI18n ? (
      <Text
        flavour={labelFlavour}
        i18nKey={labelI18n}
        ref={labelRef}
        tag={labelTag}
        variant={labelVariant as TextProps['variant']}
        {...rest}
      >
        {label} {required && '*'}
        {children}
      </Text>
    ) : null;
  }
);
